import { NgModule } from '@angular/core';
import { SecondFaModal } from './second-fa-modal/second-fa-modal';
import { NgxQRCodeModule } from '@jonyadamit/ngx-qrcode-ivy';
import { EnrollmentComponent } from './enrollment.component';
import { FidoTokenComponent } from './fido-token/fido-token.component';
import { UsernamelessModalComponent } from './fido-token/usernameless-modal/usernameless-modal.component';
import { SoftTokenComponent } from './soft-token/soft-token.component';
import { TranslateModule } from '@ngx-translate/core';
import { NgbModule, NgbAccordionModule } from '@ng-bootstrap/ng-bootstrap';
import { LaddaModule } from 'angular2-ladda'
import { NgSelectModule } from '@ng-select/ng-select'
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';

@NgModule({
  declarations: [
    SecondFaModal,
    EnrollmentComponent,
    FidoTokenComponent,
    UsernamelessModalComponent,
    SoftTokenComponent,
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    NgxQRCodeModule,
    TranslateModule,
    NgbModule,
    NgbAccordionModule,
    LaddaModule,
    NgSelectModule
  ],
  exports: [
    EnrollmentComponent,
    FidoTokenComponent,
    SoftTokenComponent,
    NgbAccordionModule]
})

export class EnrollmentModule { }
